<ng-container *ngIf="toolbarConfig$ | async as config">
  <glxy-page-toolbar class="toolbar">
    <glxy-page-nav *ngIf="config.backButton">
      <glxy-page-nav-button
        previousPageTitle="{{ config.backButton.previousPageTitle }}"
        previousPageUrl="{{ config.backButton.previousPageUrl }}"
      ></glxy-page-nav-button>
    </glxy-page-nav>

    <glxy-page-title ngProjectAs="glxy-page-title">
      {{ config.title }}
    </glxy-page-title>

    <glxy-page-title-actions ngProjectAs="glxy-page-title-actions">
      <ng-container #titleAction></ng-container>
    </glxy-page-title-actions>

    <glxy-page-actions ngProjectAs="glxy-page-actions" *ngFor="let action of config.actions">
      <ng-container *ngIf="!action.icon; else iconButton">
        <button
          mat-flat-button
          [color]="action.color"
          [disabled]="action.disabled"
          [glxyTooltip]="action.tooltip?.label"
          [tooltipPositions]="action?.tooltip?.position"
          (click)="action.onClick()"
        >
          {{ action.label }}
        </button>
      </ng-container>
      <ng-template #iconButton>
        <button
          mat-icon-button
          [color]="action.color"
          [disabled]="action.disabled"
          [glxyTooltip]="action.tooltip?.label"
          [tooltipPositions]="action?.tooltip?.position"
          (click)="action.onClick()"
        >
          <mat-icon>{{ action.icon }}</mat-icon>
          {{ action.label }}
        </button>
      </ng-template>
    </glxy-page-actions>
  </glxy-page-toolbar>
</ng-container>
